// extracted by mini-css-extract-plugin
module.exports = {"percentField":"MessageField_percentField__2QtBW"};